import { render, staticRenderFns } from "./ProducerForm.vue?vue&type=template&id=52381b29&scoped=true&"
import script from "./ProducerForm.vue?vue&type=script&lang=ts&"
export * from "./ProducerForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProducerForm.vue?vue&type=style&index=0&id=52381b29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52381b29",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
